import { Mail, Send } from "lucide-react";

export default function SubmitGamePage() {
  return (
    <div className="min-h-screen py-12 md:py-24">
      {/* Hero Section */}
      <section className="max-w-3xl mx-auto px-6 md:px-12 mb-16">
        <div className="animate-fade-in-up text-center">
          <h1 className="font-serif font-bold text-4xl md:text-5xl text-slate-900 mb-6 tracking-tight">
            Get Your Game Listed
          </h1>
          <p className="font-sans text-slate-600 text-lg leading-relaxed">
            We'd love to showcase your self-published board game. Here's what you need to know.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-stone-200 shadow-sm">
          <div className="font-sans text-slate-600 leading-relaxed space-y-6">
            <p>
              To get your game on the site, just send us a photo of your game and a link to where people can buy it. The listing fee is £10 — this is a one-time payment.
            </p>

            <p>
              Once a year we may send an optional donation request for site upkeep — but it's never required.
            </p>

            <p>
              <strong className="text-slate-900">Crowdfunding projects are free.</strong> If you're running a crowdfunding campaign, we recognise you're trying to raise money, not spend it! Just let us know and we'll add a link to your campaign on our Crowdfunding page.
            </p>

            <p>
              <strong className="text-slate-900">Our one rule:</strong> The game must be designed and published by the same person or people. If your game gets picked up by a publisher later, please let us know.
            </p>
          </div>

          {/* Contact */}
          <div className="text-center mt-10 pt-10 border-t border-stone-200">
            <div className="w-14 h-14 bg-[#7C3AED] rounded-2xl flex items-center justify-center mx-auto mb-4">
              <Mail className="w-7 h-7 text-white" />
            </div>
            <h3 className="font-serif font-bold text-xl text-slate-900 mb-2">
              Ready to Submit?
            </h3>
            <p className="font-sans text-slate-600 mb-6">
              Email us your game photo and purchase link
            </p>
            <a
              href="mailto:garethsherwood@yahoo.com?subject=Game%20Submission&body=Hi%2C%0A%0AI'd%20like%20to%20submit%20my%20game.%0A%0AGame%20Name%3A%20%0APurchase%20Link%3A%20%0A%0A(Please%20attach%20a%20photo)"
              className="inline-flex items-center gap-3 bg-[#7C3AED] text-white px-8 py-4 rounded-full font-sans font-bold hover:bg-[#6D28D9] hover:scale-105 active:scale-95 transition-all shadow-lg shadow-[#7C3AED]/20"
              data-testid="email-link"
            >
              <Send className="w-5 h-5" />
              garethsherwood@yahoo.com
            </a>
          </div>

        </div>
      </section>
    </div>
  );
}
